// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tHG56FAVLgJTZ7aGH0lye{padding-bottom:4px;position:relative}.tHG56FAVLgJTZ7aGH0lye:after{content:\" \";background-color:#ccc;position:absolute;bottom:0;left:0;width:100%;height:4px;cursor:row-resize}.lT_iCtI0fMxwxY9fyY00i{background-color:red}\n", ""]);
// Exports
exports.locals = {
	"resizableH": "tHG56FAVLgJTZ7aGH0lye",
	"pendingDelete": "lT_iCtI0fMxwxY9fyY00i"
};
module.exports = exports;
